"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getObjectAsJSONFile;
function getObjectAsJSONFile(jsonObject) {
  var jsonString = JSON.stringify(jsonObject);
  return new File([jsonString], "newTxtAreaFile.json", {
    type: "application/json"
  });
}